import { TbaParameter } from './tba-parameter';
import { Tba } from './tba';
import { Container } from './container';
import { Collapsible } from '../interfaces';

export class AdjustmentType implements Collapsible {
  adjustmentTypeId: number;
  name: string;
  description: string;
  excluded = false;
  tba = new Tba();
  tbaParameter = new TbaParameter();
  container: Container;
  collapsed: boolean;
}
